/* global $ */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useReactToPrint } from 'react-to-print';
import ThermalBillPrint from '../ThermalBillPrint';
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';
import Footer from '../components/Footer';

function Gstbilling() {
    // Initial state with one row
    const [rows, setRows] = useState([
        { id: 1, product: "", product_name: "", hsncode: "", gstrate: "", quantity: "", rate: "", discount: 0, tax: 0, amount: 0 },
    ]);
    // State for products and customers
    const [products, setProducts] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    // State for billing summary
    const [discountType, setDiscountType] = useState("percentage");
    const [discount, setDiscount] = useState(0);
    const [taxableAmount, setTaxableAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [roundOff, setRoundOff] = useState(0);
    const [mobileNumber, setMobileNumber] = useState("");
    const [customerData, setCustomerData] = useState(null);
    const [showAddButton, setShowAddButton] = useState(false);
    const [newCustomerName, setNewCustomerName] = useState("");
    const [searchedMobileNumber, setSearchedMobileNumber] = useState(""); // Store searched mobile number

    const inputRefs = useRef({});

    // Ref to track if initialization has happened
    const initializationDone = useRef(false);
    // Create a ref to store pending selections
    const pendingSelections = useRef([]);
    // Create a flag to prevent discount type changes from triggering product changes
    const isDiscountChanging = useRef(false);

    const [printData, setPrintData] = useState(null);
    const [isPrintEnabled, setIsPrintEnabled] = useState(false);
    const [lastSavedBillingData, setLastSavedBillingData] = useState(null);
    const contentRef = useRef();
    const printComponentRef = useRef(null);
    const [printReadyData, setPrintReadyData] = useState(null);
    const printContainerRef = useRef(null);

    const companyname = localStorage.getItem("companyname")
    const address1 = localStorage.getItem("address1")
    const address2 = localStorage.getItem("address2")
    const city = localStorage.getItem("city");
    const zipcode = localStorage.getItem("zipcode");
    const companyphone = localStorage.getItem("companyphone")



    // First useEffect just for initialization
    useEffect(() => {
        // Only run this once when component mounts
        if (!initializationDone.current) {
            initializationDone.current = true;
        }

        // Cleanup function
        return () => {
            $(".select2").off("change");
        };
    }, []);

    // Second useEffect that runs when rows change to update selects
    useEffect(() => {
        if (initializationDone.current && products && products.length) {
            console.log("Initializing Select2 with", products.length, "products available");

            // First destroy existing select2 instances to prevent duplicates
            $(".select2").each(function () {
                if ($(this).hasClass("select2-hidden-accessible")) {
                    $(this).select2("destroy");
                }
            });

            // Re-initialize all select2 elements
            $(".select2").select2();

            // Re-attach event listeners
            $(".product-select.select2").on("change", function () {
                const selectedValue = $(this).val();
                const rowId = $(this).data("id");
                handleProductChange(selectedValue, rowId);
            });

            // Special handling for discount type dropdown
            $("#discount-type-select").on("change", function () {
                isDiscountChanging.current = true;
                const selectedType = $(this).val();
                console.log("Discount type select2 changed to:", selectedType);
                handleDiscountTypeChange(selectedType);
                setTimeout(() => {
                    isDiscountChanging.current = false;
                }, 100);
            });
        }
    }, [rows, products]);

    useEffect(() => {
        calculateTotal();
    }, [rows, discount, discountType]);

    useEffect(() => {
        fetchProducts();
        fetchCustomers();
    }, []);


    // Improved handleDiscountTypeChange function
    const handleDiscountTypeChange = (selectedType) => {
        console.log("Changing discount type to:", selectedType);
        setDiscountType(selectedType);

        // Force the select2 visual to update
        setTimeout(() => {
            $("#discount-type-select").val(selectedType).trigger('change.select2');
        }, 50);
    };

    // Process any pending selections when products become available
    useEffect(() => {
        if (products && products.length && pendingSelections.current.length > 0) {
            console.log("Processing pending selections now that products are loaded");

            // Process all pending selections
            pendingSelections.current.forEach(({ selectedProductId, rowId }) => {
                handleProductChange(selectedProductId, rowId);
            });

            // Clear the pending selections
            pendingSelections.current = [];
        }
    }, [products]);


    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            addRow(() => {
                setTimeout(() => {
                    document.querySelector(".new-row input")?.focus();
                }, 0);
            });
        }
    };


    // Fetch products from API
    const fetchProducts = async () => {
        try {
            const response = await axiosInstance.get("/gstproduct/");
            setProducts(response.data);
            console.log("demo", response.data);
            console.log(products)
            console.log("Product ID", products.id)
        } catch (error) {
            console.error("Error fetching products", error);
        }
    };

    // Fetch customers from API
    const fetchCustomers = async () => {
        try {
            const response = await axiosInstance.get("/customer/");
            setCustomers(response.data);
        } catch (error) {
            console.error("Error fetching customers", error);
        }
    };


    // const updateRow = (id, field, value) => {
    //     setRows(rows.map((row) =>
    //         row.id === id ? { ...row, [field]: value } : row
    //     ));
    // };

    // Update row values (modified to handle quantity changes affecting amount)
    const updateRow = (rowId, field, value) => {
        setRows(prevRows =>
            prevRows.map(row => {
                if (row.id === rowId) {
                    let updatedRow = { ...row, [field]: value };

                    // If updating quantity, recalculate amount only if product is selected
                    if (field === "quantity" && row.product) {
                        const quantity = parseFloat(value) || 0;
                        const rate = parseFloat(row.rate) || 0;
                        const gstrate = parseFloat(row.gstrate) || 0;

                        let amount = quantity * rate;

                        // Only set amount if both quantity and rate exist
                        if (quantity > 0 && rate > 0 && gstrate > 0) {
                            amount += (amount * gstrate) / 100;
                            updatedRow.amount = amount;
                        } else {
                            updatedRow.amount = 0;
                        }

                        console.log(`Updated amount: ${updatedRow.amount} (quantity=${quantity}, rate=${rate})`);
                    }

                    return updatedRow;
                }
                return row;
            })
        );
    };

    const addRow = () => {
        const newId = uuidv4();
        setRows((prevRows) => {
            const newRows = [...prevRows, {
                id: newId,
                product: "",
                product_name: "",
                hsncode: "",
                gstrate: "",
                quantity: "",
                rate: "",
                amount: 0
            }];

            setTimeout(() => {
                if (inputRefs.current[newId]) {
                    inputRefs.current[newId].focus(); // Focus first input of new row
                }
            }, 10);

            return newRows;
        });
    };

    // Function to remove a row
    const removeRow = (id) => {
        setRows(rows.filter((row) => row.id !== id));
        //calculateTotal();
    };

    const handleProductChange = (selectedProductId, rowId) => {
        console.log("inside handleProductChange", selectedProductId, rowId);
        console.log("Products array:", products);

        // Skip if this is a discount type change event
        if (isDiscountChanging.current) {
            console.log("Skipping product change as discount type is changing");
            return;
        }

        if (!products || !products.length) {
            console.warn("⚠️ Products are empty! Queuing selection for later processing.");
            pendingSelections.current.push({ selectedProductId, rowId });
            return;
        }

        // Log the exact structure of products to see what fields are available
        console.log("First product structure:", JSON.stringify(products[0]));

        // Make sure we're using string comparison if IDs are strings
        const selectedProduct = products.find(p => String(p.id) === String(selectedProductId));
        console.log("🔍 Found Product:", selectedProduct ? JSON.stringify(selectedProduct) : "❌ Not Found");

        if (!selectedProduct) {
            console.error(`❌ No product found with ID: ${selectedProductId}`);
            return;
        }

        // Check what field contains the rate - it might be named differently
        console.log("Product fields:", Object.keys(selectedProduct));

        // Try to extract rate (check all possible field names)
        // Extract necessary values from the selected product
        let productRate = selectedProduct.rate !== undefined ? parseFloat(selectedProduct.rate) : 0;
        let productHsnCode = selectedProduct.hsncode || ""; // Default empty string if not available
        let productGstRate = selectedProduct.gstrate !== undefined ? parseFloat(selectedProduct.gstrate) : 0;
        let productName = selectedProduct.product_name || ""; // Get the product name

        console.log("💰 Product Rate:", productRate, "📌 HSN Code:", productHsnCode, "🧾 GST Rate:", productGstRate, "📝 Product Name:", productName);

        // Get the current row to see what's already there
        //const currentRow = rows.find(r => r.id === rowId);
        //console.log("Current row before update:", currentRow);

        setRows((prevRows) =>
            prevRows.map((row) => {
                if (row.id === rowId) {
                    // Only calculate amount if quantity exists
                    const quantity = parseFloat(row.quantity) || 0;
                    let amount = quantity > 0 ? quantity * productRate : 0;

                    // Apply GST if applicable
                    if (productGstRate > 0) {
                        amount += (amount * productGstRate) / 100;
                    }

                    let updatedRow = {
                        ...row,
                        product: selectedProductId,
                        product_name: productName,
                        rate: productRate,
                        hsncode: productHsnCode,
                        gstrate: productGstRate,
                        amount: amount
                    };

                    console.log(`Updated row will be:`, updatedRow);
                    return updatedRow;
                }
                return row;
            })
        );

        // // After state update, let's check if it worked
        // setTimeout(() => {
        //     const updatedRow = rows.find(r => r.id === rowId);
        //     console.log("Row after update (timeout):", updatedRow);
        // }, 100);
    };

    // Make sure calculateTotal is using the current state values
    const calculateTotal = () => {
        let subtotal = rows.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
        let discountAmount = 0;
        console.log("Calculating total with discount type:", discountType, "and discount value:", discount);

        // Make sure you're using the current discountType state here
        if (discountType === "percentage") {
            discountAmount = (subtotal * parseFloat(discount)) / 100;  // Calculate percentage-based discount
            console.log("Applied percentage discount:", discountAmount);
        } else if (discountType === "fixed") {
            discountAmount = parseFloat(discount);  // Directly subtract fixed amount
            console.log("Applied fixed discount:", discountAmount);
        } else {
            console.warn("Invalid discount type:", discountType);
        }

        let finalAmount = subtotal - discountAmount;
        let roundOffValue = Math.round(finalAmount) - finalAmount;

        console.log("Calculation results:", {
            subtotal,
            discountType,
            discountAmount,
            finalBeforeRounding: finalAmount,
            roundOffValue,
            finalTotal: finalAmount + roundOffValue
        });

        setTaxableAmount(subtotal);
        setTotalAmount(finalAmount + roundOffValue);
        setRoundOff(roundOffValue);
    };

    const searchCustomer = async () => {
        // Validate mobile number
        if (!searchedMobileNumber || searchedMobileNumber.length < 10) {
            Swal.fire({
                icon: 'warning',
                title: 'Invalid Mobile Number',
                text: 'Please enter a valid mobile number',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
            return;
        }

        try {
            const response = await axiosInstance.get(`/customer/search/mobile?mobile=${searchedMobileNumber}`);
            const data = response.data;

            if (data && data.name) {
                setCustomerData(data);
                setSelectedCustomer(response.data);
                setSearchedMobileNumber(data.mobileno || "")
                setShowAddButton(false); // Hide Add button
            } else {
                setSelectedCustomer(null);
                setCustomerData(null);
                setShowAddButton(true); // Show Add button if no customer found
            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                // Customer not found, show Add button
                setSelectedCustomer(null);
                setCustomerData(null);
                setShowAddButton(true);
            } else {
                console.error("Error fetching customer:", error);
                // Handle other errors (e.g., server errors)
            }
        }
    };

    const saveCustomer = async (e) => {
        // Prevent default form submission behavior
        e.preventDefault();

        console.log("name:", newCustomerName, "MobileNo:", searchedMobileNumber);
        try {
            const customerData = {
                name: newCustomerName,
                mobileno: searchedMobileNumber,
                created_by: localStorage.getItem("user_id")
            };
            const response = await axiosInstance.post("/customer", customerData);
            console.log(response)

            if (response.status === 201 || response.status === 200) {
                // Update customers list with new customer
                setCustomers(prevCustomers => [...prevCustomers, response.data]);

                // Set the newly created customer as selected
                setSelectedCustomer(response.data);
                setCustomerData(response.data);

                // Clear input fields
                setNewCustomerName("");
                setSearchedMobileNumber("");

                // Hide modal if using Bootstrap modal
                $('#add_customer').modal('hide');

                // Show success alert
                Swal.fire({
                    icon: 'success',
                    title: 'Customer Created!',
                    text: 'The Customer record has been created.',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });

                setShowAddButton(false);
            } else {
                throw new Error('Failed to save customer');
            }
        } catch (error) {
            console.error('Error saving customer:', error);

            // Show error alert
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.response?.data?.message || 'Failed to create customer',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
        }
    };


    // Submit billing data
    const handleSubmit = async (e) => {
        // Prevent default form submission
        e.preventDefault();

        // Validate required fields
        if (!selectedCustomer) {
            Swal.fire("Error", "Please select a valid customer!", "error");
            return;
        }

        // Validate that at least one product is added
        if (rows.length === 0 || rows.every(row => !row.product)) {
            Swal.fire("Error", "Please add at least one product!", "error");
            return;
        }

        // Validate that each product row has a quantity
        const invalidRows = rows.filter(row => row.product && (!row.quantity || row.quantity <= 0));
        if (invalidRows.length > 0) {
            Swal.fire("Error", "Please enter valid quantity for all selected products!", "error");
            return;
        }

        const billingData = {
            customer_id: selectedCustomer.id,
            customer_name: selectedCustomer.name || selectedCustomer.customer_name,
            customer_mobile: searchedMobileNumber || selectedCustomer.mobileno,
            products: rows.map(({ product, product_name, hsncode, gstrate, quantity, rate, amount }) => ({
                product_id: product,
                product_name: product_name,
                hsncode: hsncode,
                gstrate: parseFloat(gstrate),
                quantity: parseFloat(quantity),
                rate: parseFloat(rate),
                amount: parseFloat(amount),
            })),
            discount_type: discountType,
            discount: discount,
            discount_amount: discountType === "percentage"
                ? (taxableAmount * discount) / 100
                : discount,
            taxable_amount: taxableAmount,
            round_off: roundOff,
            total_amount: totalAmount,
            user_id: localStorage.getItem("user_id"),
            username: localStorage.getItem("name"),
        };

        try {
            const response = await axiosInstance.post("/gstbilling", billingData);

            // Store the last saved billing data
            setLastSavedBillingData(billingData);
            // Set print ready data to trigger rendering of print component
            setPrintReadyData(billingData);

            // Enable print option
            setIsPrintEnabled(true);

            Swal.fire({
                icon: 'success',
                title: 'Billing Record Saved!',
                text: 'The billing record has been successfully created.',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });

            // Optional: Reset form after successful submission
            resetForm();
        } catch (error) {
            console.error("Error submitting billing", error);
            setIsPrintEnabled(false);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.response?.data?.error || 'Failed to save billing data!',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
        }
    };

    // Add a reset form method
    const resetForm = () => {
        // Reset rows to initial state
        setRows([{
            id: 1,
            product: "",
            product_name: "",
            hsncode: "",
            gstrate: "",
            quantity: "",
            rate: "",
            discount: 0,
            tax: 0,
            amount: 0
        }]);

        // Reset other state variables
        setDiscountType("percentage");
        setDiscount(0);
        setTaxableAmount(0);
        setTotalAmount(0);
        setRoundOff(0);
        setMobileNumber("");
        setCustomerData(null);
        setSelectedCustomer(null);
        setSearchedMobileNumber("");
    };

    // Direct printing function that doesn't rely on react-to-print
    const printBill = () => {
        console.log('Print button clicked');

        if (!printReadyData) {
            console.error('No billing data available for printing');
            Swal.fire('Error', 'No billing data available for printing', 'error');
            return;
        }

        try {
            // Clone the print component to manipulate without affecting the original DOM
            const printContent = document.createElement('div');
            printContent.innerHTML = printContainerRef.current.innerHTML;

            // Create an iframe to handle printing (avoids layout issues)
            const printFrame = document.createElement('iframe');
            printFrame.style.position = 'absolute';
            printFrame.style.top = '-9999px';
            printFrame.style.left = '-9999px';
            printFrame.style.width = '58mm';
            printFrame.style.height = '100mm';
            document.body.appendChild(printFrame);

            // Wait for iframe to be ready
            printFrame.onload = () => {
                const frameDoc = printFrame.contentDocument || printFrame.contentWindow.document;

                // Add necessary styles
                frameDoc.head.innerHTML = `
                    <style>
                        @page {
                            size: 58mm 100mm;
                            margin: 2mm;
                        }
                        body {
                            font-family: monospace;
                            font-size: 8px;
                            margin: 0;
                            padding: 0;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
                        th, td {
                            border: 1px solid #000;
                            padding: 1mm;
                        }
                    </style>
                `;

                // Add the content
                frameDoc.body.innerHTML = printContent.innerHTML;

                // Wait for styles to be applied
                setTimeout(() => {
                    // Print
                    printFrame.contentWindow.print();

                    // Remove the iframe after printing
                    setTimeout(() => {
                        document.body.removeChild(printFrame);
                    }, 1000);
                }, 500);
            };

            // Trigger the load event for the iframe
            printFrame.src = 'about:blank';

        } catch (error) {
            console.error('Print failed:', error);
            Swal.fire('Error', 'Failed to print bill', 'error');
        }
    };


    return (
        <div>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="card mb-0">
                        <div className="card-body">
                            <div className="page-header">
                                <div className="content-page-header">
                                    <h5>Add Bill</h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group-item">
                                        <div className="card-table">
                                            <div className="card-body">
                                                <div className="table-responsive no-pagination">
                                                    <table className="table table-center table-hover datatable">
                                                        <thead className="thead-light">
                                                            <tr>
                                                                <th>Product / Service</th>
                                                                <th>HSN Code</th>
                                                                <th>Rate</th>
                                                                <th>GST</th>
                                                                <th>Quantity</th>
                                                                <th>Amount</th>
                                                                <th className="no-sort">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {rows.map((row) => (
                                                                <tr key={row.id}>
                                                                    <td style={{ minWidth: "250px" }}>
                                                                        <select className="select2 product-select"
                                                                            ref={(el) => (inputRefs.current[row.id] = el)}
                                                                            onKeyDown={handleKeyDown}
                                                                            value={row.product || ""}
                                                                            data-id={row.id}
                                                                            onChange={(e) => {
                                                                                console.log("Dropdown changed:", e.target.value);
                                                                                // Pass both the value (ID) and the product name to your handler
                                                                                const selectedProduct = products.find(product => product.id.toString() === e.target.value);
                                                                                console.log("nearselect", selectedProduct?.product_name)
                                                                                handleProductChange(e.target.value, row.id);
                                                                            }}>
                                                                            <option value="">Select Product</option>
                                                                            {products.map((product) => (
                                                                                <option key={product.id} value={product.id}>
                                                                                    {product.product_name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={row.hsncode !== undefined && row.hsncode !== null ? row.hsncode : ""}
                                                                            readOnly
                                                                        />
                                                                        {/* Debug display */}
                                                                        <div style={{ display: 'none' }}>
                                                                            Raw hsncode value: {JSON.stringify(row.hsncode)}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={row.rate !== undefined && row.rate !== null ? row.rate : ""}
                                                                            readOnly
                                                                        />
                                                                        {/* Debug display */}
                                                                        <div style={{ display: 'none' }}>
                                                                            Raw rate value: {JSON.stringify(row.rate)}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={row.gstrate !== undefined && row.gstrate !== null ? row.gstrate : ""}
                                                                            readOnly
                                                                        />
                                                                        {/* Debug display */}
                                                                        <div style={{ display: 'none' }}>
                                                                            Raw gstrate value: {JSON.stringify(row.gstrate)}
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control"
                                                                            value={row.quantity}
                                                                            onChange={(e) => updateRow(row.id, "quantity", e.target.value)}
                                                                            onKeyDown={handleKeyDown}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        {/* Only show amount if both product and quantity exist */}
                                                                        {row.product && row.quantity > 0 ? `${row.amount || 0}` : '-'}
                                                                    </td>
                                                                    <td className="d-flex align-items-center">
                                                                        <button onClick={addRow} className="btn btn-sm btn-success me-2">
                                                                            <i className="fe fe-plus"></i>
                                                                        </button>
                                                                        {rows.length > 1 && (
                                                                            <button onClick={() => removeRow(row.id)} className="btn btn-sm btn-danger">
                                                                                <i className="fe fe-trash-2"></i>
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="row">
                                                <div className="col-lg-7">
                                                    <div className="input-block mb-3">
                                                        <label>Discount Type</label>
                                                        <select
                                                            id="discount-type-select"
                                                            className="select2"
                                                            value={discountType}
                                                            onChange={(e) => handleDiscountTypeChange(e.target.value)}
                                                        >
                                                            <option value="percentage">Percentage (%)</option>
                                                            <option value="fixed">Fixed (₹)</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-5">
                                                    <div className="input-block mb-3">
                                                        <label>Discount</label>
                                                        <input
                                                            type="number"
                                                            value={discount}
                                                            className="form-control"
                                                            placeholder="Enter Discount"
                                                            onChange={(e) => setDiscount(Number(e.target.value))}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4"></div>
                                    </div>
                                    <div className="form-group-item border-0 p-0">
                                        <div className="row">
                                            <div className="col-xl-6 col-lg-12">
                                                <div className="form-group-bank">
                                                    <div className="row align-items-center">
                                                        <div className="col-md-8">
                                                            <div className="input-block mb-3">
                                                                <label>Mobile No</label>
                                                                <input type="text" className="form-control" value={searchedMobileNumber} placeholder="Enter Mobile No" onChange={(e) => setSearchedMobileNumber(e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group-plus css-equal-heights">
                                                                <a className="btn btn-primary form-plus-btn me-2" href="#" onClick={searchCustomer}><i className="fe fe-search"></i></a>
                                                                {showAddButton && (
                                                                    <button className="btn btn-primary form-plus-btn" data-bs-toggle="modal" data-bs-target="#add_customer" onClick={() => setNewCustomerName('')}>
                                                                        <i className="fe fe-plus-circle"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row align-items-center">
                                                        {/* Display customer details */}
                                                        {customerData && (
                                                            <div className="col-md-12 mt-2">
                                                                <span><strong>Name:</strong> {customerData.name}</span><br />
                                                                <span><strong>Mobile:</strong> {customerData.mobileno}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-6 col-lg-12">
                                                <div className="form-group-bank">
                                                    <div className="invoice-total-box">
                                                        <div className="invoice-total-inner">
                                                            <p>Taxable Amount <span>{taxableAmount.toFixed(2)}</span></p>
                                                            <p>Discount <span>{discountType === "percentage" ? `${discount}%` : `₹${discount.toFixed(2)}`}</span></p>
                                                            <p>Round Off <span>{roundOff.toFixed(2)}</span></p>
                                                        </div>
                                                        <div className="invoice-total-footer">
                                                            <h4>Total Amount <span>₹{totalAmount.toFixed(2)}</span></h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <form onSubmit={handleSubmit} className="add-customer-btns text-end">
                                        <button type="reset" onClick={resetForm} className="btn btn-primary cancel me-2">Cancel</button>
                                        <button type="reset" className="btn btn-primary cancel me-2">Save</button>
                                        <button type="submit" className="btn btn-primary">Save & Send</button>
                                        {/* Conditionally render print button */}
                                        {isPrintEnabled && (
                                            <button
                                                type="button"
                                                className="btn btn-primary ms-2"
                                                onClick={printBill}
                                            >
                                                Print Bill
                                            </button>
                                        )}
                                    </form>
                                    {/* Hidden print component - IMPORTANT */}
                                    <div style={{ display: 'none' }} ref={printContainerRef}>
                                        <div style={{ width: '58mm', padding: '2mm', fontFamily: 'Arial, sans-serif', margin: '0 auto' }}>
                                            {/* Business Header */}
                                            <div style={{ textAlign: 'center', marginBottom: '3mm' }}>
                                                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold' }}>{companyname}</h3>
                                                <p style={{ margin: '1mm 0', fontSize: '12px' }}>{address1}</p>
                                                <p style={{ margin: '1mm 0', fontSize: '12px' }}>{address2}</p>
                                                <p style={{ margin: '1mm 0', fontSize: '12px' }}>{city} - {zipcode}</p>
                                                <p style={{ margin: '1mm 0', fontSize: '12px' }}>Contact: {companyphone}</p>
                                            </div>

                                            {/* Bill Details */}
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                borderBottom: '1px dashed #000',
                                                paddingBottom: '2mm',
                                                fontSize: '12px'
                                            }}>
                                                <div>
                                                    <p style={{ margin: '1mm 0', fontWeight: 'bold' }}>Bill No: {Math.floor(Math.random() * 10000)}</p>
                                                    <p style={{ margin: '1mm 0' }}>Date: {new Date().toLocaleString()}</p>
                                                </div>
                                                {printReadyData?.customer_name && (
                                                    <div style={{ textAlign: 'right' }}>
                                                        <p style={{ margin: '1mm 0', fontWeight: 'bold' }}>{printReadyData.customer_name}</p>
                                                        <p style={{ margin: '1mm 0' }}>{printReadyData.customer_mobile}</p>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Product Details */}
                                            <div style={{ marginTop: '3mm', fontSize: '12px' }}>
                                                {/* Headers */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    fontWeight: 'bold',
                                                    borderBottom: '1px solid #000',
                                                    paddingBottom: '1mm'
                                                }}>
                                                    <div style={{ width: '40%', textAlign: 'left' }}>Item</div>
                                                    <div style={{ width: '15%', textAlign: 'right' }}>Qty</div>
                                                    <div style={{ width: '20%', textAlign: 'right' }}>Rate</div>
                                                    <div style={{ width: '25%', textAlign: 'right' }}>Amount</div>
                                                </div>

                                                {/* Products */}
                                                {printReadyData?.products?.map((product, index) => (
                                                    <div key={index} style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        borderBottom: '1px dotted #000',
                                                        padding: '1.5mm 0'
                                                    }}>
                                                        <div style={{ width: '40%', textAlign: 'left' }}>{product.product_name}</div>
                                                        <div style={{ width: '15%', textAlign: 'right' }}>{product.quantity}</div>
                                                        <div style={{ width: '20%', textAlign: 'right' }}>{product.rate}</div>
                                                        <div style={{ width: '25%', textAlign: 'right' }}>{product.amount}</div>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Summary */}
                                            <div style={{
                                                marginTop: '3mm',
                                                borderTop: '1px dashed #000',
                                                paddingTop: '2mm',
                                                fontSize: '12px'
                                            }}>
                                                <p style={{ margin: '1mm 0', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Taxable Amount:</span>
                                                    <span>{printReadyData?.taxable_amount?.toFixed(2)}</span>
                                                </p>
                                                <p style={{ margin: '1mm 0', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Discount ({printReadyData?.discount_type}):</span>
                                                    <span>{printReadyData?.discount_type === 'percentage' ?
                                                        `${printReadyData?.discount}%` :
                                                        `₹${printReadyData?.discount?.toFixed(2)}`}</span>
                                                </p>
                                                <p style={{ margin: '1mm 0', display: 'flex', justifyContent: 'space-between' }}>
                                                    <span>Round Off:</span>
                                                    <span>{printReadyData?.round_off?.toFixed(2)}</span>
                                                </p>
                                                <p style={{
                                                    margin: '2mm 0',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    fontWeight: 'bold',
                                                    borderTop: '1px solid #000',
                                                    paddingTop: '2mm',
                                                    fontSize: '14px'
                                                }}>
                                                    <span>Total Amount:</span>
                                                    <span>₹{printReadyData?.total_amount?.toFixed(2)}</span>
                                                </p>
                                            </div>

                                            {/* Footer */}
                                            <div style={{
                                                textAlign: 'center',
                                                marginTop: '4mm',
                                                fontSize: '14px',
                                                borderTop: '1px dashed #000',
                                                paddingTop: '2mm'
                                            }}>
                                                <p style={{ margin: 0, fontWeight: 'bold' }}>Thank You! Visit Again</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div >
            {/* /Page Wrapper */}

            {/* Add customer Modal */}
            <div className="modal custom-modal fade" id="add_customer" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <div className="form-header modal-header-title text-start mb-0 align-center">
                                <h4 className="mb-0">Add Customer</h4>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">

                            </button>
                        </div>
                        <form onSubmit={saveCustomer}>

                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Customer Name</label>
                                            <input type="text" className="form-control" placeholder="Enter Name" value={newCustomerName} onChange={(e) => setNewCustomerName(e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-block mb-3">
                                            <label>Mobile Number</label>
                                            <input type="number" className="form-control" value={searchedMobileNumber} readOnly />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer add-tax-btns">
                                <button type="reset" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">Cancel</button>
                                <button type="submit" className="btn btn-primary paid-continue-btn">Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* /Add customer Modal */}
        </div>
    )
}


export default Gstbilling